import React, { Fragment, useState, useEffect } from "react";
import styled from "styled-components";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";

import { getSidebarDataAdmin } from "./SidebarDataAdmin";
import { getSidebarDataUsuario } from "./SidebarDataUsuario";
import SubMenu from "./SubMenu";

import { IconContext } from "react-icons/lib";
import Cookies from "universal-cookie";

import logo from "../img/LOGO-Icontec-2019_ver_white.png";

const primary = "#0085ca";
const dark = "#006fa8";

/* =========================================================
   NAVBAR
========================================================= */

const Nav = styled.div`
  background: linear-gradient(135deg, ${primary}, ${dark});
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1100;
`;

/* =========================================================
   BOTÓN MENU
========================================================= */

const MenuButton = styled.div`
  font-size: 28px;
  cursor: pointer;
`;

/* =========================================================
   TITULO
========================================================= */

const Title = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-weight: bold;
`;

/* =========================================================
   LOGO
========================================================= */

const Logo = styled.img`
  height: 45px;
`;

/* =========================================================
   SIDEBAR
========================================================= */

const SidebarNav = styled.nav`
  background: linear-gradient(180deg, ${primary}, ${dark});
  width: 260px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: ${({ sidebar }) => (sidebar ? "0" : "-270px")};
  transition: 0.3s;
  z-index: 1200;
`;

/* =========================================================
   BOTÓN CERRAR
========================================================= */

const CloseButton = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  font-size: 26px;
  cursor: pointer;
  z-index: 1300;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 35px;
  height: 35px;
  border-radius: 50%;

  transition: 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: rotate(90deg);
  }
`;

/* =========================================================
   CONTENIDO SIDEBAR
========================================================= */

const SidebarWrap = styled.div`
  margin-top: 70px;
  padding-top: 40px;
  overflow-y: auto;
  height: calc(100vh - 70px);
`;

/* =========================================================
   SIDEBAR
========================================================= */

const Sidebar = ({ isAuth }) => {
  const [sidebar, setSidebar] = useState(false);

  const [userType, setUserType] = useState(null);
  const [correo, setCorreo] = useState(null);

  const cookies = new Cookies();

  // =========================================================
  // LEER COOKIES
  // =========================================================

  const cargarCookies = () => {
    const tipo = cookies.get("tipo");
    const mail = cookies.get("correo");

    console.log("SIDEBAR - Cookie tipo:", tipo);
    console.log("SIDEBAR - Cookie correo:", mail);

    if (
      tipo !== undefined &&
      tipo !== null &&
      mail !== undefined &&
      mail !== null
    ) {
      setUserType(String(tipo));
      setCorreo(mail);

      return true;
    }

    return false;
  };

  // =========================================================
  // CARGAR INFORMACIÓN DE USUARIO
  // =========================================================

  useEffect(() => {
    // Si no está autenticado limpiamos
    if (!isAuth) {
      setUserType(null);
      setCorreo(null);
      return;
    }

    // =======================================================
    // PRIMER INTENTO
    // =======================================================

    const encontrada = cargarCookies();

    if (encontrada) {
      return;
    }

    // =======================================================
    // SEGUNDO INTENTO
    //
    // Esto permite darle tiempo a InfoReportes para crear
    // la cookie "tipo".
    // =======================================================

    const timer = setTimeout(() => {
      cargarCookies();
    }, 300);

    return () => {
      clearTimeout(timer);
    };
  }, [isAuth]);

  // =========================================================
  // SI CAMBIAN LAS COOKIES DESPUÉS DEL LOGIN
  // HACEMOS UNA SEGUNDA VERIFICACIÓN
  // =========================================================

  useEffect(() => {
    if (!isAuth) return;

    const interval = setInterval(() => {
      const tipo = cookies.get("tipo");
      const mail = cookies.get("correo");

      if (
        tipo !== undefined &&
        tipo !== null &&
        mail !== undefined &&
        mail !== null
      ) {
        setUserType(String(tipo));
        setCorreo(mail);

        clearInterval(interval);
      }
    }, 200);

    // Dejamos de revisar después de 5 segundos
    const timeout = setTimeout(() => {
      clearInterval(interval);
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [isAuth]);

  // =========================================================
  // ESPERAR A TENER TIPO Y CORREO
  // =========================================================

  if (
    userType === null ||
    userType === undefined ||
    correo === null ||
    correo === undefined
  ) {
    return null;
  }

  // =========================================================
  // DETERMINAR MENU
  // =========================================================

  const menuData =
    userType === "1"
      ? getSidebarDataAdmin(correo)
      : getSidebarDataUsuario(correo);

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <Fragment>
      <IconContext.Provider value={{ color: "#fff" }}>
        {/* ===================================================
            NAVBAR
        ==================================================== */}

        <Nav>
          <MenuButton onClick={() => setSidebar(!sidebar)}>
            <FaIcons.FaBars />
          </MenuButton>

          <Title>ICON-ANALYTICS</Title>

          <Logo src={logo} alt="Icontec" />
        </Nav>

        {/* ===================================================
            SIDEBAR
        ==================================================== */}

        <SidebarNav sidebar={sidebar}>
          {/* =================================================
              BOTÓN CERRAR
          ================================================== */}

          <CloseButton onClick={() => setSidebar(false)}>
            <AiIcons.AiOutlineClose />
          </CloseButton>

          {/* =================================================
              MENÚ
          ================================================== */}

          <SidebarWrap>
            {menuData.map((item, index) => (
              <SubMenu key={index} item={item} />
            ))}
          </SidebarWrap>
        </SidebarNav>
      </IconContext.Provider>
    </Fragment>
  );
};

export default Sidebar;
